<template>
	<el-dialog
		:modelValue="open"
		@update:modelValue="$emit('update:open', $event)"
		:title="'Neue Gruppenzugehörigkeit'"
		:before-close="(done) => dialogBeforeClose(done, waiting)"
	>
		<TheForm
			:model="request"
			:rules="rules"
			:waiting="waiting"
			:waitingMsg="texts.formErrors.waiting"
			:showErr="showErr"
			:errMsg="errMsg"
			ref="formRef"
			:id="id"
		>
			<el-form-item label="" prop="selectedRole">
				<el-select v-model="request.selectedRole" placeholder="Bitte wählen">
					<el-option v-for="item in roleOptions" :key="item.value" :label="item.label" :value="item" />
				</el-select>
			</el-form-item>
		</TheForm>

		<template #footer>
			<div class="button-panel">
				<TheButton type="danger" @buttonclick="addRoleToUser" :disabled="waiting" :loading="waiting">Hinzufügen</TheButton>
				<TheButton type="default" @buttonclick="handleClose">Abbrechen</TheButton>
			</div>
		</template>
	</el-dialog>
</template>

<script lang="ts">
import { addRoleToUser } from '@/requests/users';
import { dialogBeforeClose, resetForm, validateForm } from '@/utils/functions';
import type { FormInstance } from 'element-plus';
import { defineComponent, ref } from 'vue';
import { RoleDto } from '../../types/types';
import { texts } from '../../utils/texts';
import TheButton from '../TheButton.vue';
import TheForm from '../TheForm.vue';

export default defineComponent({
	name: 'DialogNewRole',
	components: {
		TheButton,
		TheForm,
	},
	props: {
		open: {
			type: Boolean,
			required: true,
		},
		userId: {
			type: String,
			required: false,
		},
		roleOptions: {
			type: Array as () => any[],
			required: true,
		},
	},
	emits: ['addNewRole', 'update:open', 'reload'],
	setup() {
		const formRef = ref<FormInstance | null>(null);

		return {
			formRef,
		};
	},
	data() {
		return {
			request: {
				selectedRole: null as RoleDto | null,
			},
			rules: {
				selectedRole: [{ required: true, message: texts.formErrors.reqMissing, trigger: ['blur', 'change'] }],
			},
			id: 'NewRoleForm',
			waiting: false,
			showErr: false,
			errMsg: texts.user.addRoleFailed,
		};
	},
	computed: {
		texts() {
			return texts;
		},
	},
	methods: {
		// addNewRole() {
		// 	if (this.request.selectedRole) {
		// 		this.$emit('addNewRole', this.request.selectedRole);
		// 		this.request.selectedRole = null;
		// 		this.$emit('update:open', false);
		// 	}
		// },
		async addRoleToUser() {
			const isValid = await validateForm(this.formRef, this.id);
			if (!isValid) return;

			this.waiting = true;

			if (this.userId) {
				// @ts-ignore
				const addResult = await addRoleToUser(this.userId, this.request.selectedRole.value.name);
				if (addResult.success) {
					this.handleClose(true);
				} else {
					this.showErr = true;
				}
			} else {
				/* for new creations of users or contacts */
				this.$emit('addNewRole', this.request.selectedRole);
				this.handleClose(false);
			}

			this.waiting = false;
		},
		handleClose(reload: Boolean) {
			resetForm(this.formRef, this.id);
			this.showErr = false;

			if (reload) {
				this.$emit('reload');
			}

			this.$emit('update:open', false);
		},
		dialogBeforeClose,
	},
});
</script>
